import Vue from "vue"
import Vuex from "vuex"
import utils from "./modules/utils"
Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    utils
  },
  state: {
    themeMode: localStorage.getItem("Theme")
  },
  getters: {
    isDarkMode(state) {
      return state.themeMode === "dark"
    }
  },
  mutations: {
    setThemeMode(state, mode) {
      state.themeMode = mode
      localStorage.setItem("Theme", mode)
    }
  },
  actions: {}
})
export default store
